import React from 'react';
import PropTypes from 'prop-types';

import { FormGroup as MUIFormGroup } from '@material-ui/core';

export const FormGroup = props => <MUIFormGroup {...props} />;

FormGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object,
  row: PropTypes.bool
};

export default FormGroup;
